// src/main.jsx
import React from 'react';
import ReactDOM from 'react-dom/client';
import { RouterProvider } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';

import router from './routes';
import './services/firebase'; // Garante inicialização única do Firebase
import './index.css';
import 'react-toastify/dist/ReactToastify.css';

import { ComparadorProvider } from './context/ComparadorContext'; // ✅ Importado aqui

const stripePromise = loadStripe(import.meta.env.VITE_STRIPE_PUBLIC_KEY);

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <Elements stripe={stripePromise}>
      <ComparadorProvider>
        {' '}
        {/* ✅ Envolvendo a aplicação */}
        <RouterProvider router={router} />
        <ToastContainer
          position="bottom-right"
          autoClose={3000}
          hideProgressBar={false}
          pauseOnHover
          closeOnClick
          newestOnTop
          rtl={false}
          draggable
          pauseOnFocusLoss
        />
      </ComparadorProvider>
    </Elements>
  </React.StrictMode>
);
